import api from '@/api'
import Vue from 'vue';
import permissions from '@/api/permissions'
import _ from 'lodash'

export default {
  state: {
    publicTender: {}
  },

  getters: {
    publicTender: s => tenderId => s.publicTender[tenderId]
  },

  mutations: {
    setPublicTender(s, data) {
      const model = {
        ...data,
        method: new api.TenderMethod(data.method),
        participationMode: new api.TenderParticipationMode(data.open ? api.TenderParticipationMode.OPEN : api.TenderParticipationMode.CLOSED),
        publicationDate: data.published ? new Date(data.published) : undefined,
        lastChangeDate: data.changed ? new Date(data.changed) : undefined,
        permissions: permissions.init(data.permissions),
        lots: (data.lots || []).map(e => ({
          id: e.id,
          name: e.name,
          identifier: e.lotNum,
          currency: new api.Currency(e.currency),
          price: e.initialPrice
        }))
      };

      Vue.set(s.publicTender, model.id, model);
    }
  },

  actions: {
    handlePublicTender({commit}, data) {
      commit('setPublicTender', data);
    },

    async fetchPublicTender({dispatch, getters}, {tenderId}) {
      let error;

      try {
        const response = await api.get(`tenders/${tenderId}/public`);
        const {status, result, errorCode} = response.data;

        if (status === 200) {
          dispatch('handlePublicTender', result);
          return getters.publicTender(tenderId);
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch (e) {
        console.error('Something went wrong while creating new lot', e);
        error = e;
      }

      if (error) {
        throw error
      }
    }
  }
}
